
import { ActionReference, GameObjectReference, GameState } from "@shared/types";
import { LitElement, TemplateResult, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { getItemInfo } from "../helpers";
import { getState } from "../services/routeService";


@customElement("display-item-menu")
export class GameItemDisplay extends LitElement {
    @property({ type: String }) private item: string | undefined = "";
    @property({ type: Array }) private gameObjects: any[] | undefined = [];
    public static styles = [css`
        .item .buttons {
            display: flex;
            flex-direction: column;
            overflow: auto;
            padding: 10px 10px 0 10px;
        }

        .item .button {
            background-color: #207000;
            border: 1px solid #003b0a;
            padding: 5px 10px;
            margin: 0 0 10px 10px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            user-select: none;
        }
        .item .buttonSmall {
            background-color: #207000;
            border: 1px solid #003b0a;
            padding: 5px 10px;
            margin: 0 0 10px 10px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            user-select: none;
            font-size: 20px;
        }


        .item .button.active,
        .item .button:hover {
            background-color: #00cc22;
        }
    `];
        private actionButtons?: ActionReference[];
        private selectedActionButton?: ActionReference;
        private selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();
        
        private menuOpen: boolean = false;
        private usableMenu: boolean = false;
        private itemInfo: any = null;

        private updateState(state: GameState): void {
            //Reset the component
            this.actionButtons = state.actions;
    
            this.selectedActionButton = undefined;
            this.selectedGameObjectButtons.clear();
    
            this.requestUpdate();

        }


        private async refreshState(): Promise<void> {
            const state: GameState = await getState();
            
            this.updateState(state);

            this.dispatchEvent(new CustomEvent("state-updated"));
        }

        private async toggleMenu(): Promise<void> {

            await this.refreshState();

            this.menuOpen = !this.menuOpen;

            if (this.menuOpen && this.item) {
                this.itemInfo = await getItemInfo(this.item);
            }
            // Move this.requestUpdate() outside the if block
            this.requestUpdate();
        }

        private  async showUsableMenu(): Promise<void> {
            await this.refreshState();
            this.usableMenu = !this.usableMenu;
            this.requestUpdate();
        }
        

        protected render(): TemplateResult {
            return html`
                <div class="item">
                    <a @click=${this.toggleMenu} class="button">${this.item}</a>
                    ${this.menuOpen && this.actionButtons ? html`
                        <div class="buttons">
                            ${this.actionButtons?.map(
                                (button: ActionReference) => 
                                this.itemInfo?.interfaces.includes(button.alias) && button.alias !== "pickup" ? html`
                                    <a
                                        class="button ${this.selectedActionButton === button ? "active" : ""}"
                                        @click=${(): void => void this.dispatchEvent(new CustomEvent("action-clicked", { detail: {button:button, item:this.item} }))}
                                    >${button.label}</a>
                                ` : ""
                            )}
                            ${this.itemInfo?.useableActionAlias ? html`
                            <a
                                class="button"
                                @click=${(): void => void this.showUsableMenu()}
                            >${this.itemInfo.useableActionName}</a>
                            <div class="buttons">
                            ${this.usableMenu ? html`
                            ${this.gameObjects?.map(
                                (button: GameObjectReference) => html`
                                    <a
                                        class="buttonSmall ${this.selectedGameObjectButtons.has(button) ? "active" : ""}"
                                        @click=${(): void => void this.dispatchEvent(new CustomEvent("action-clicked", { detail: {button: {alias: this.itemInfo.useableActionAlias}, item: button.alias} }))}
                                    >${button.name}</a>
                                `
                            )}
                        `: ""}
                            </div>
                        ` : ""}
                        </div>
                        

                        
                            ${this.itemInfo.interfaces.length === 0 ? html`<a> This item has no actions</a>` : html``}
                        </div>
                    ` : html``}
                </div>
            `;
        }
    }